module.exports = __webpack_public_path__ + "static/media/Teppanyaki.17de01bf.jpg";